import axios from 'axios';
import { HolidayInterface } from '../interfaces/holiday';
import { CalendarUserInterface } from '../interfaces/calendar-user';
import { ExtraCalendarUserInterface } from '../interfaces/extra-calendar-user';
import { getRotaPath } from '../lib/white-cache';

export const getShiftUser = async (
  pointOfSaleId: string,
  startTime: string,
  endTime: string
): Promise<[CalendarUserInterface[], ExtraCalendarUserInterface[]]> => {
  const fetchShiftUser = async (): Promise<CalendarUserInterface[]> => {
    try {
      const {
        data: { data },
      } = await axios.get(
        `${getRotaPath()}/ShiftUser/PointOfSale/${pointOfSaleId}?dc=${Date.now()}`,
        {
          params: {
            startTime,
            endTime,
          },
        }
      );
      return data;
    } catch (error) {
      return [];
    }
  };

  const fetchShiftCalendarUser = async (): Promise<
    ExtraCalendarUserInterface[]
  > => {
    try {
      const {
        data: { data },
      } = await axios.get(
        `${getRotaPath()}/ExtraShiftUser/PointOfSale/${pointOfSaleId}?dc=${Date.now()}`,
        {
          params: {
            startTime,
            endTime,
          },
        }
      );
      return data;
    } catch (error) {
      return [];
    }
  };

  const fetchHoliday = async (): Promise<HolidayInterface[]> => {
    try {
      const {
        data: { data },
      } = await axios.post(`${getRotaPath()}/Holiday/Range`, {
        startDate: startTime,
        endDate: endTime,
      });
      return data;
    } catch (error) {
      return [];
    }
  };

  try {
    const responses = await Promise.all([
      fetchShiftUser(),
      fetchShiftCalendarUser(),
    ]);

    return responses as any;
  } catch (error) {
    return [[], []];
  }
};
